module.exports = function smoothstep (min, max, value) {
  var x = Math.max(0, Math.min(1, (value-min)/(max-min)));
  return x*x*(3 - 2*x);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/smoothstep/index.js
// module id = 326
// module chunks = 0